<template>
	<div :class="blockClasses" :style="customStyles">
		<div class="recht-block-base" :class="rootClasses">
			<div class="container">
                <div>
					<h2 v-if="data.title && data.title.length" :class="`recht-title recht-text-${data.textAlignment}`" :style="textColor">
						{{ data.title }}
					</h2>
					<div v-if="data.text" :class="`recht-richtext recht-text-${data.textAlignment}`" v-html="data.text" :style="textColor"></div>
					<Buttons
						v-if="data.buttons && (data.buttons.length || typeof data.buttons == 'object' && Object.keys(data.buttons).length)"
						:buttons="data.buttons"
						:alignment="data.textAlignment"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Banner',
		props: {
			data: {
				type: Object,
				default: () => {},
			}
		},
		components: {
			Buttons: () => import('@/blocks_components/Buttons.vue')
		},
		computed: {
			customStyles() {
				if (this.data?.backgroundImage?.length) return {
					['background-image']: `url('${this.data.backgroundImage}')`,
					['background-repeat']: 'no-repeat',
					['background-position']: 'center center',
					['background-size']: 'cover'
				}

				return {};
			},
			rootClasses() {
				return {};
			},
			textColor() {
				if (this.data?.textColor?.length) return {
					['color']: this.data.textColor
				}

				return {
					['color']: '#fff'
				};
			},
			blockClasses() {
				let result = {
					['recht-block']: true,
					['recht-banner-block']: true
				}

				if (this.data?.backgroundImage?.length) result['has-background'] = true;

				return result;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.recht-banner-block {
		min-height: 70vh;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		.container > div > *:not(:last-child) {
			margin-bottom: 1rem;
		}

		::v-deep {
			.recht-buttons {
				margin-top: -1rem !important;

				> * {
					min-width: 155px;
				}
			}
		}
	}
</style>
